import { render, staticRenderFns } from "./SettingsView.vue?vue&type=template&id=d893cada&scoped=true"
import script from "./SettingsView.vue?vue&type=script&lang=ts"
export * from "./SettingsView.vue?vue&type=script&lang=ts"
import style0 from "./SettingsView.vue?vue&type=style&index=0&id=d893cada&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d893cada",
  null
  
)

export default component.exports